import { render, staticRenderFns } from "./YoutubeLinkEditor.vue?vue&type=template&id=0b25058e&"
import script from "./YoutubeLinkEditor.vue?vue&type=script&lang=js&"
export * from "./YoutubeLinkEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports